@if(showHeader){
<fgb-page-header
  [pageTitle]="mobileTitle"
  [backButtonLink]="'/'"
/>
}

<router-outlet></router-outlet>
